module.exports = __webpack_public_path__ + "img/18.18dd5463.jpg";